export const squareMetersToHectares = (squareMeters: number) => {
  return squareMeters / 10000;
};
